/* eslint-disable */
'use strict';

module.exports = require('./lib');
